const uploadMessagePhotoUp = {
  click: 'Click or Drag the photo here...',
  error: 'Unsupported file',
  success: 'Drop the photo here'
};

export default uploadMessagePhotoUp;
